module.exports = __webpack_public_path__ + "assets/src/style/img/footer-gemeente-emmen.png?eb4729a814dc1eb48ba8608623924cbe";